// import { Link } from "react-router-dom";
import Gdg1 from "../assets/gdg2021.jpg"
import Gdg2 from "../assets/gdg2021f.jpg"
import Gdg3 from "../assets/inhagdg2022.jpg"
import GdgPlov from "../assets/plovgdg.jpg"

function Gdgevents() {
    return (
        <div className="blog container__blog general-margin_top">
            <p className="blog-text">2021-yildan buyon Toshkentda bo'lib o'tadigan GDG eventlarida muntazam qatnashib kelaman,sizga ham tavsiya qilgan bo'lardim, juda ajoyib bo'ladi.Quyida batafsil ko'rishingiz mumkin.</p>
            <img className="m" src={Gdg1} alt="setup img" width={630} />
            <p className="mb-5 volunteer-sub-text">GDG event in 2021 in New Uzbekistan University</p>

            <p className="blog-text">Farkhod aka bilan product designer, o'sha paytlar UX/UIga qiziqib yurgan vaqtlarim.🙂</p>
            <img className="m" src={Gdg2} alt="setup img" width={630} />
            <p className="mb-5 volunteer-sub-text">GDG event in 2021 in New Uzbekistan University</p>

            <img className="m" src={Gdg3} alt="setup img" width={630} />
            <p className="mb-5 volunteer-sub-text">GDG event in 2022 in Inha University</p>

            <p className="blog-text">Eng qiziq joyini aytaymi?! Tekin dasturxonga nima deysiz,talabalarga ayni muddaoda.Xullas,borish keragi bollar.😃</p>
            <img className="m" src={GdgPlov} alt="setup img" width={630} />
            <p className="mb-5 volunteer-sub-text">GDG event in 2022 in Inha University</p>

            {/* <Link className="btn btn-outline-info back-btn" to="/"> ← Back </Link> */}
        </div>
    );
}

export default Gdgevents;
